import { isDevMode, isIntegrationMode } from '@utils/env.ts'

function Lights() {
  return (
    <>
      <ambientLight
        intensity={1.3}
        color='#F6F6FF'

      />

      <directionalLight
        position={[10, 20, 10]}
        intensity={2}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={50}
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
        shadow-camera-helper={(isDevMode || isIntegrationMode) ? true : undefined}
      />

      <directionalLight
        position={[-10, 20, 10]}
        intensity={2}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={50}
        shadow-camera-left={-20}
        shadow-camera-right={20}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
        shadow-camera-helper={(isDevMode || isIntegrationMode) ? true : undefined}
      />
    </>
  )
}

export default Lights